import {
    useRef,
    useState
} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useUsageRecords} from '../hooks/useUsageRecords.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';
import {useUsageRecordsSelection} from '../hooks/useUsageRecordsSelection.ts';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {update} from '../services/UsageRecordsService.ts';
import {buildUpdateUsageRecordInput} from '../services/buildUsageRecordInput.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";
import {UsageRecord} from '../types';
import {useQueryClient} from '@tanstack/react-query';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useUsageRecordsSelection();
    const {columns} = useTableColumns();
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<UsageRecord | null>(null);
    const queryClient = useQueryClient();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useUsageRecords();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const handleDrawerSubmit = async (values: UsageRecord) => {
        if (selectedRecord?.id) {
            await update(selectedRecord.id, buildUpdateUsageRecordInput(values) as UsageRecord);
            queryClient.invalidateQueries({queryKey: ['usage-records']});
        }
    };

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => {
                    setSelectedRecord(record);
                    setDrawerOpened(true);
                }}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>

            <FormDrawer
                record={selectedRecord || {} as UsageRecord}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </SimpleGrid>
    );
};
